//
// Generated class BusinessPaymentFee
//

/// <reference path="BusinessPaymentFee_ManagedObject.ts" />

class BusinessPaymentFee extends BusinessPaymentFee_ManagedObject
{
    // Display strings for the fee rule enums. They mirror the combobox options in the
    // payment fee layouts so the read-only cell reads the same as the editable one.
    static cardBrandTypeString(type:number):string {
        switch (type) {
            case 1: return MIOLocalizeString("AMEX", "AMEX");
            case 2: return MIOLocalizeString("OTHER", "Other");
            default: return MIOLocalizeString("VISA_MASTERCARD", "Visa/Mastercard");
        }
    }

    static fundingSourceString(source:number):string {
        switch (source) {
            case 1: return MIOLocalizeString("DEBIT", "Debit");
            case 2: return MIOLocalizeString("CREDIT", "Credit");
            default: return MIOLocalizeString("BOTH", "Both");
        }
    }

    static cardTypeString(type:number):string {
        switch (type) {
            case 1: return MIOLocalizeString("CONSUMER", "Consumer");
            case 2: return MIOLocalizeString("BUSINESS_COMMERCIAL", "Business/Commercial");
            default: return MIOLocalizeString("BOTH", "Both");
        }
    }

    static channelString(channel:number):string {
        switch (channel) {
            case 1: return MIOLocalizeString("IN_PERSON", "In-Person");
            case 2: return MIOLocalizeString("TAP_TO_PAY", "Tap to Pay");
            case 3: return MIOLocalizeString("ONLINE", "Online");
            default: return MIOLocalizeString("ANY_CHANNEL", "Any channel");
        }
    }

    static threeDSModeString(mode:number):string {
        switch (mode) {
            case 1: return MIOLocalizeString("NO_3DS", "No 3DS");
            case 2: return MIOLocalizeString("ONLY_3DS", "Only 3DS");
            default: return MIOLocalizeString("ANY_3DS", "Any 3DS");
        }
    }
}
